var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2937 2.43652C16.3088 0.0119596 19.1098 0 19.1098 0C19.1098 0 19.5265 2.27967 17.5249 4.47608C15.3874 6.82106 12.9581 6.43744 12.9581 6.43744C12.9581 6.43744 12.5022 4.59337 14.2937 2.43698V2.43652Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2145 8.03423C14.2513 8.03423 16.1747 6.7334 18.679 6.7334C22.9894 6.7334 24.6851 9.53376 24.6851 9.53376C24.6851 9.53376 21.3687 11.0821 21.3687 14.8387C21.3687 19.0765 25.5002 20.537 25.5002 20.537C25.5002 20.537 22.6121 27.9592 18.7113 27.9592C16.9193 27.9592 15.5268 26.8567 13.6387 26.8567C11.7505 26.8567 9.80588 28.0002 8.56255 28.0002C5.0003 28.0006 0.5 20.9602 0.5 15.3005C0.5 9.64094 4.30911 6.8116 7.88194 6.8116C10.2044 6.8116 12.0069 8.03469 13.2145 8.03469V8.03423Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.5346364b464da0e400d13530b3edcb3d.svg";
export { ForwardRef as ReactComponent };